import { render, staticRenderFns } from "./SortDate.vue?vue&type=template&id=227fe949&scoped=true&"
import script from "./SortDate.vue?vue&type=script&lang=js&"
export * from "./SortDate.vue?vue&type=script&lang=js&"
import style0 from "./SortDate.vue?vue&type=style&index=0&id=227fe949&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227fe949",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
